import Api from '@/api/Api'
import store from '@/store'
import toast from '@/mixins/toast'

export default {
    
    addMofa (payload, type) {
        return Api().post('/mofa/'+ type, payload).then( (response) => {
                toast.success( "Saved successfully")
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },
    updateMofa (payload, type) {
        return Api().put('/mofa/'+ type, payload).then( (response) => {
                toast.success( "Saved successfully")
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },
    fetchByNotificationId (payload, type) {
        return Api().get('/mofa/'+ type +"/"+ payload).then( (response) => {
                return response.data[0];
            })
            .catch( error => {
                console.log(error)
                if (error.response) {
                      toast.error( error.response.message, "Error")
                    } else if (error.request) {
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    // CENTCOM
    addMofaCentcom (payload, type) {
        return Api().post('/mofa/'+ type +'/centcom', payload).then( (response) => {
                toast.success( "Saved successfully")
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    updateMofaCentcom (payload, type) {
        return Api().put('/mofa/'+ type +'/centcom', payload).then( (response) => {
                toast.success( "Saved successfully")
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    fetchCentcomByNotificationId (payload, type) {
        return Api().get('/mofa/'+ type +'/centcom/'+ payload).then( (response) => {
                return response.data[0];
            })
            .catch( error => {
                console.log(error)
                if (error.response) {
                      toast.error( error.response.message, "Error")
                    } else if (error.request) {
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },
}    


// WEBPACK FOOTER //
// ./src/api/MofaService.js